var map = {
	"./72/compose-email.svg": 72354,
	"./add-candidates.svg": 56262,
	"./additional-form.svg": 48398,
	"./arrow-down-sml.svg": 71345,
	"./arrow-right-sml.svg": 4720,
	"./arrow-up-sml.svg": 30911,
	"./at.svg": 48781,
	"./ats-sidebar.svg": 57006,
	"./attachment.svg": 78911,
	"./attention-circle.svg": 80822,
	"./avatar-full.svg": 77507,
	"./back.svg": 4331,
	"./bell-active.svg": 6020,
	"./bell-filled.svg": 99899,
	"./bin-full.svg": 73108,
	"./bin.svg": 70325,
	"./boost-large.svg": 75465,
	"./boost.svg": 31894,
	"./bot-conversation.svg": 51651,
	"./bot.svg": 57426,
	"./branch.svg": 55270,
	"./briefcase.svg": 6021,
	"./bulk-move-pipeline.svg": 46061,
	"./calendar.svg": 76046,
	"./candidate-color.svg": 64040,
	"./candidate.svg": 71241,
	"./candidates-moved.svg": 20073,
	"./candidates.svg": 29557,
	"./chart-pie.svg": 50269,
	"./clock-full.svg": 24054,
	"./clock-rewind.svg": 86222,
	"./clock.svg": 74660,
	"./cog-filled.svg": 44448,
	"./cog.svg": 6704,
	"./cogs-dual.svg": 36349,
	"./collect.svg": 2366,
	"./comments.svg": 95047,
	"./company.svg": 1416,
	"./content.svg": 52059,
	"./cross-bold.svg": 43122,
	"./cross-c-f.svg": 25983,
	"./cross.svg": 62313,
	"./crown.svg": 98030,
	"./cv.svg": 26098,
	"./dashboard.svg": 56655,
	"./drag-dots.svg": 61269,
	"./drag-drop.svg": 73991,
	"./drag-handle.svg": 7006,
	"./drag-stripes.svg": 21275,
	"./duplicate.svg": 55041,
	"./eb-sidebar.svg": 16729,
	"./eb-visits.svg": 54913,
	"./edit-form.svg": 57746,
	"./email-sent.svg": 94723,
	"./email.svg": 59795,
	"./emails_filled.svg": 18498,
	"./empty-state-plant.svg": 65114,
	"./envelope_filled.svg": 43534,
	"./event.svg": 83819,
	"./eye.svg": 95865,
	"./file-folder.svg": 4315,
	"./first.svg": 94122,
	"./form-answer.svg": 47776,
	"./form-filled.svg": 55070,
	"./form.svg": 76985,
	"./forms-dual.svg": 36888,
	"./forms.svg": 17389,
	"./forward-arrow.svg": 55184,
	"./forward.svg": 31563,
	"./freeform-text.svg": 506,
	"./funnel.svg": 40668,
	"./gear.svg": 52704,
	"./globe-magnify.svg": 90561,
	"./grab.svg": 90101,
	"./hand.svg": 87789,
	"./happy-face.svg": 63552,
	"./heart.svg": 28223,
	"./help.svg": 88239,
	"./history.svg": 50087,
	"./image.svg": 39754,
	"./images.svg": 62866,
	"./info-f-c.svg": 52029,
	"./interview.svg": 74522,
	"./job-bag.svg": 75351,
	"./job-created.svg": 85090,
	"./job-f.svg": 91596,
	"./job-list.svg": 98656,
	"./job-views.svg": 63663,
	"./jobibot-color.svg": 31631,
	"./jobibot-sad.svg": 86481,
	"./jobibot-text.svg": 86952,
	"./jobibot.svg": 84850,
	"./jobilla-dashboard.svg": 30428,
	"./jobilla-logo-grayscale-flat.svg": 13275,
	"./jobilla-logo-grayscale.svg": 96639,
	"./jobilla-text-color-logo.svg": 24843,
	"./jobilla-text-logo.svg": 48709,
	"./landing-page.svg": 62971,
	"./last.svg": 50998,
	"./link-new-tab.svg": 95251,
	"./link-to-website.svg": 37358,
	"./link-url.svg": 17645,
	"./link.svg": 18333,
	"./location-f.svg": 84084,
	"./lock.svg": 92339,
	"./login.svg": 21801,
	"./logo-j.svg": 9471,
	"./logout.svg": 13354,
	"./magic-wand.svg": 9354,
	"./magnifying-glass.svg": 9361,
	"./mail.svg": 20941,
	"./manage-teams.svg": 20247,
	"./megaphone-f.svg": 33635,
	"./megaphone.svg": 50870,
	"./message-bubble.svg": 75458,
	"./message.svg": 76079,
	"./multi-choice.svg": 43632,
	"./new-document.svg": 85731,
	"./next.svg": 1840,
	"./no-search-result.svg": 84129,
	"./notes.svg": 79789,
	"./notification-bell.svg": 3823,
	"./on-off.svg": 45796,
	"./open-link.svg": 73519,
	"./padlock.svg": 74202,
	"./paper-write.svg": 7185,
	"./pencil.svg": 13487,
	"./people-join-pipeline.svg": 18760,
	"./people-moved-pipeline.svg": 69501,
	"./phone.svg": 26802,
	"./play-circle.svg": 87344,
	"./plus-circle.svg": 12688,
	"./plus.svg": 98411,
	"./pool.svg": 91105,
	"./previous.svg": 26323,
	"./progress-donut.svg": 51490,
	"./refresh.svg": 86336,
	"./sad-face.svg": 87614,
	"./save.svg": 76182,
	"./send-email.svg": 84994,
	"./send.svg": 63493,
	"./sent.svg": 11287,
	"./seo.svg": 27441,
	"./settings-emails.svg": 1916,
	"./settings-f.svg": 87422,
	"./settings-integrations.svg": 20737,
	"./settings-talents.svg": 64514,
	"./settings-users.svg": 13945,
	"./setup-finalization.svg": 69637,
	"./single-choice.svg": 54889,
	"./social-medias.svg": 47772,
	"./speech-bubble.svg": 12603,
	"./star-filled.svg": 74586,
	"./star-outline.svg": 56183,
	"./stopsign.svg": 15200,
	"./structure.svg": 49115,
	"./style.svg": 31686,
	"./subitem-branch.svg": 4797,
	"./subitem-last.svg": 7202,
	"./success-tag.svg": 19095,
	"./talent-email.svg": 20976,
	"./talent-moved.svg": 95468,
	"./talent-new.svg": 10749,
	"./talent-pool-sidebar.svg": 87871,
	"./talent-removed.svg": 85078,
	"./talent.svg": 40119,
	"./talents-email.svg": 59464,
	"./talents-moved.svg": 12346,
	"./talents-removed.svg": 40406,
	"./talents.svg": 98772,
	"./te-palvelut.svg": 75584,
	"./team.svg": 51565,
	"./teams-avatar.svg": 91650,
	"./teams.svg": 62884,
	"./text-field.svg": 73134,
	"./thumb-tag.svg": 94891,
	"./tick-circle.svg": 23092,
	"./tick-sml.svg": 18558,
	"./tick-square.svg": 18840,
	"./tick.svg": 64113,
	"./trash-bin.svg": 72641,
	"./upload.svg": 10948,
	"./user-avatar.svg": 86819,
	"./video.svg": 32262,
	"./warning-f.svg": 64952,
	"./warning.svg": 70837,
	"./web.svg": 73529,
	"./webpage.svg": 24977,
	"./wrench.svg": 73441,
	"./xmas-jobibot-text.svg": 44018,
	"./xmas-jobibot.svg": 67196,
	"./xmas-jobilla-dashboard.svg": 83775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66882;